import React from 'react';
import { NavLink } from 'react-router-dom';
import AccountActive from '@/assets/store/icon/account-active.svg';
import AccountInActive from '@/assets/store/icon/account-inactive.svg';
import BookActive from '@/assets/store/icon/book-active.svg';
import BookInActive from '@/assets/store/icon/book-inactive.svg';
import DonationActive from '@/assets/store/icon/donation-active.svg';
import DonationInActive from '@/assets/store/icon/donation-inactive.svg';
import HomeActive from '@/assets/store/icon/home-active.svg';
import HomeInActive from '@/assets/store/icon/home-inactive.svg';
import MediaActive from '@/assets/store/icon/media-active.svg';
import MediaInActive from '@/assets/store/icon/media-inactive.svg';

interface NavItem {
  to: string;
  label: string;
  iconActive: string;
  iconInactive: string;
}

const NAV_ITEMS: NavItem[] = [
  {
    to: '/store/home',
    label: 'Beranda',
    iconActive: HomeActive,
    iconInactive: HomeInActive,
  },
  {
    to: '/store/book',
    label: 'Buku',
    iconActive: BookActive,
    iconInactive: BookInActive,
  },
  {
    to: '/store/donation',
    label: 'Donasi',
    iconActive: DonationActive,
    iconInactive: DonationInActive,
  },
  {
    to: '/store/media',
    label: 'Media',
    iconActive: MediaActive,
    iconInactive: MediaInActive,
  },
  {
    to: '/store/account',
    label: 'Akun',
    iconActive: AccountActive,
    iconInactive: AccountInActive,
  },
];

const BottomNavigation = () => {
  return (
    <nav className="fixed z-20 bottom-0 left-0 right-0 flex h-16 items-center justify-around border-t border-gray-200 bg-white">
      {NAV_ITEMS.map(({ to, label, iconActive, iconInactive }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `flex flex-col items-center gap-1 reg12 ${isActive ? 'text-text-blue-100' : 'text-text-grey'}`
          }
        >
          {({ isActive }) => (
            <>
              <img src={isActive ? iconActive : iconInactive} alt={label} className="h-7 w-7" />
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNavigation;
